import { Container, Row, Col } from "react-grid-system";
import newsletterData from "@content/en/newsletter/newsletters.yaml";
import Breadcrumbs from "@components/Breadcrumbs";
import CardLayout from "@components/layout/CardLayout";
import { NewsletterContainerLight } from "@components/newsletter/NewsletterContainerLight";

const { newsletters } = newsletterData;

const NewsletterPage = () => (
  <>
    <Container>
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs links={[{ name: "Dev News", url: "/developer-news" }]} />
          <h1>Blues Dev News</h1>
          <p>
            The official monthly Blues newsletter. Written by developers, for
            developers.
          </p>
        </Col>
      </Row>

      <div className="signup">
        <NewsletterContainerLight pageSource="Dev News Page" />
      </div>

      <h2>Recent Newsletters</h2>

      <CardLayout
        cards={newsletters.map((newsletter) => ({
          link: newsletter.link,
          title: newsletter.title,
          description: newsletter.excerpt,
          banner: newsletter.banner,
          date: newsletter.date,
        }))}
      />
    </Container>
    <style jsx>
      {`
        p {
          margin-bottom: 3rem;
        }
        h2 {
          margin-top: 3rem;
        }

        .signup :global(.newsletter-container) {
          margin-left: 0;
        }
      `}
    </style>
  </>
);

export default NewsletterPage;
